import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../css/patch-notes.css';
import { Link } from "react-router-dom";
import { formatDate } from '../utils/dateUtils.js';
import truncate from 'html-truncate';
import DOMPurify from 'dompurify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTag } from '@fortawesome/free-solid-svg-icons';
import i18n from "i18next";

const RecentPatchNotes = () => {
    const [recentPatchNotes, setRecentPatchNotes] = useState([]);
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();

    const truncateContent = (html, length) => {
        return truncate(html, length, { ellipsis: '...' });
    };

    useEffect(() => {
        const loadRecentPatchNotes = () => {
            setLoading(true);
            fetch(`${process.env.REACT_APP_API_URL}/api/patch-notes?lang=${i18n.language}&page=1&limit=5`, {
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (!response.ok) throw new Error('Failed to fetch recent patch notes');
                    return response.json();
                })
                .then((data) => {
                    if (data.patch_notes && Array.isArray(data.patch_notes)) {
                        setRecentPatchNotes(data.patch_notes);
                    } else {
                        setRecentPatchNotes([]);
                    }
                })
                .catch((error) => {
                    setRecentPatchNotes([]);
                })
                .finally(() => setLoading(false));
        };
        
        loadRecentPatchNotes();
    }, [i18n.language]);

    if (loading) {
        return <p>{t('patchNotes.loadingPatchNotes') || 'Loading patch notes...'}</p>;
    }

    return (
        <aside className="recent-patch-notes">
            <h2>{t('patchNotes.recentPatchNotes') || 'Recent Patch Notes'}</h2>
            {recentPatchNotes.map((patchNote) => (
                <div key={patchNote.id} className="recent-patch-note-item">
                    <div className="patch-note-data">
                        <div className="patch-note-meta">
                            <span className="recent-patch-note-date">
                                {formatDate(patchNote.created_at, {format: 'LL'})}
                            </span>
                            {patchNote.version && (
                                <span className="version-badge-small">
                                    <FontAwesomeIcon icon={faTag}/> {patchNote.version}
                                </span>
                            )}
                        </div>
                    </div>
                    <Link to={`/patch-notes/${patchNote.id}`} className="recent-patch-note-content-link">
                        <h5 className="recent-patch-note-title">{patchNote.title}</h5>
                        <div
                            className="recent-patch-note-content"
                            dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(truncateContent(patchNote.description, 50)),
                            }}
                        />
                    </Link>
                </div>
            ))}
        </aside>
    );
};

export default RecentPatchNotes;

